import { useUpdate } from '@refinedev/core';

export const useRestoreCalendarEventMutation = () => {
  const { mutateAsync, error, isLoading } = useUpdate();

  const restoreCalendarEvent = async (id: string) => {
    return mutateAsync({
      resource: `calendar-events/${id}`,
      id: 'restore',
      values: {},
    });
  };

  return {
    restoreCalendarEvent,
    isLoading,
    error,
  };
};
